var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlace = function SvgPlace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M8.682 22.212c-.145 0-.362-.073-.434-.217C7.886 21.633 0 13.312 0 8.682 0 3.907 3.907 0 8.682 0s8.682 3.907 8.682 8.682c0 4.63-7.886 12.95-8.248 13.313-.072.144-.29.217-.434.217m0-20.982c-4.052 0-7.38 3.328-7.38 7.452 0 3.184 4.993 9.261 7.38 11.938 2.46-2.677 7.38-8.754 7.38-11.938 0-4.124-3.328-7.452-7.38-7.452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M8.682 10.997a2.903 2.903 0 0 1-2.894-2.894A2.903 2.903 0 0 1 8.682 5.21a2.903 2.903 0 0 1 2.894 2.894 2.903 2.903 0 0 1-2.894 2.894m0-5.064A2.254 2.254 0 0 0 6.44 8.176a2.254 2.254 0 0 0 2.243 2.242 2.254 2.254 0 0 0 2.243-2.242 2.254 2.254 0 0 0-2.243-2.243"
  })));
};
export default SvgPlace;